<button class="container ion-padding-start" type="button" data-cy="Current cost center" (click)="openBillingInfo()" [disabled]="!project">
  <span class="text">
    {{ project?.description }}
    <ng-container *ngIf="showRole">
      ({{ project?.role | role: true:(superOperatore$ | async):(isBuyer$ | async):(isSuperBuyer$ | async) }})
    </ng-container>
  </span>
  <ion-icon class="info-icon" name="information-circle-outline"></ion-icon>
</button>
